export default "__VITE_ASSET__Cwy5aPIY__"